var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group" }, [
    _c("label", { staticClass: "form-control-label", attrs: { for: _vm.id } }, [
      _c("b", [_vm._v(_vm._s(_vm.label))])
    ]),
    _vm._v(" "),
    _c("div", [
      _vm.file.content
        ? _c("img", {
            staticStyle: { "max-height": "100px" },
            attrs: {
              src:
                "data:" + _vm.file.contentType + ";base64," + _vm.value.content,
              alt: "image"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.file.content
        ? _c("div", { staticClass: "form-text text-danger clearfix" }, [
            _c("span", { staticClass: "pull-left" }, [
              _vm._v(
                _vm._s(_vm.file.contentType) +
                  ", " +
                  _vm._s(_vm.byteSize(_vm.file.content))
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary btn-xs pull-right",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.clearInputImage(
                      _vm.file,
                      null,
                      "content",
                      "contentType",
                      "file_" + _vm.id
                    )
                  }
                }
              },
              [_c("font-awesome-icon", { attrs: { icon: "times" } })],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "btn btn-primary", attrs: { for: "file_" + _vm.id } },
        [_vm._v(_vm._s(_vm.$t("entity.action.addimage")))]
      ),
      _vm._v(" "),
      _c("input", {
        ref: "file_" + _vm.id,
        staticStyle: { visibility: "hidden" },
        attrs: { type: "file", id: "file_" + _vm.id, accept: "image/*" },
        domProps: { textContent: _vm._s(_vm.$t("entity.action.addimage")) },
        on: {
          change: function($event) {
            return _vm.setFileData($event, _vm.file, "content", true)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.file.content,
          expression: "file.content"
        }
      ],
      staticClass: "form-control",
      class: { valid: _vm.valid, invalid: !_vm.valid },
      attrs: { type: "hidden", id: _vm.id },
      domProps: { value: _vm.file.content },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.$set(_vm.file, "content", $event.target.value)
        }
      }
    }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.file.contentType,
          expression: "file.contentType"
        }
      ],
      staticClass: "form-control",
      attrs: { type: "hidden", id: _vm.id + "-ContentType" },
      domProps: { value: _vm.file.contentType },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.$set(_vm.file, "contentType", $event.target.value)
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }